module.exports = __webpack_public_path__ + "static/media/BrowserChrome.1164abd6.png";